export const SET_ACTIVE_INDEX = 'player/SET_ACTIVE_INDEX'
export const SET_SHOW_PLAYER = 'player/SET_SHOW_PLAYER'
export const SET_SHOW_PLAYLIST = 'player/SET_SHOW_PLAYLIST'

export const setActiveIndex = (payload) => ({ type: SET_ACTIVE_INDEX, payload })

export const setShowPlayer = (payload) => ({ type: SET_SHOW_PLAYER, payload })

export const setShowPlaylist = (payload) => ({ type: SET_SHOW_PLAYLIST, payload })